import { Component, inject } from '@angular/core';
import { NotificationService } from '@core/notification/notification.service';
import { IconComponent } from './icon/icon.component';

@Component({
  selector: 'app-toast',
  imports: [IconComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  notify = inject(NotificationService);
}
